// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SegmentedControl-module__ui-SegmentedControl--QT8E3 {
  box-sizing: border-box;
  display: inline-flex;
  width: fit-content;
  align-items: center;
}

.SegmentedControl-module__ui-SegmentedControl-Item--DOn35 {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  cursor: pointer;
}

.SegmentedControl-module__shape-default--nNM5x {
  height: 34px;
  gap: 2px;
  padding: 2px;
  border: 1px solid #c9c9c9;
  border-radius: 4px;
  background-color: #fff;
}

.SegmentedControl-module__shape-default--nNM5x .SegmentedControl-module__ui-SegmentedControl-Item--DOn35 {
  height: 27px;
  padding: 0 10px 1px;
  border-radius: 3px;
  color: #666;
  font-size: 0.8125rem; /* 13px */
  font-weight: 600;
  line-height: 1.2727;
}

.SegmentedControl-module__shape-default--nNM5x .SegmentedControl-module__ui-SegmentedControl-Item--DOn35.SegmentedControl-module__is-active--uyNUj {
  background-color: #000;
  color: #fff;
}

.SegmentedControl-module__shape-normal--vyM_E {
  width: 100%;
  height: 38px;
  gap: 8px;
}

.SegmentedControl-module__shape-normal--vyM_E .SegmentedControl-module__ui-SegmentedControl-Item--DOn35 {
  height: 38px;
  flex: 1 0 0;
  padding: 0 16px 1px;
  border: 1px solid #c9c9c9;
  border-radius: 19px;
  background-color: #fff;
  color: #666;
  font-size: 0.8125rem; /* 13px */
  font-weight: 600;
  line-height: 1.2727;
}

.SegmentedControl-module__shape-normal--vyM_E .SegmentedControl-module__ui-SegmentedControl-Item--DOn35.SegmentedControl-module__is-active--uyNUj {
  border-color: #000;
  background-color: #f1e9de;
  color: #1a1a1a;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/SegmentedControl/SegmentedControl.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".ui-SegmentedControl {\n  box-sizing: border-box;\n  display: inline-flex;\n  width: fit-content;\n  align-items: center;\n}\n\n.ui-SegmentedControl-Item {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.shape-default {\n  height: 34px;\n  gap: 2px;\n  padding: 2px;\n  border: 1px solid #c9c9c9;\n  border-radius: 4px;\n  background-color: #fff;\n}\n\n.shape-default .ui-SegmentedControl-Item {\n  height: 27px;\n  padding: 0 10px 1px;\n  border-radius: 3px;\n  color: #666;\n  font-size: 0.8125rem; /* 13px */\n  font-weight: 600;\n  line-height: 1.2727;\n}\n\n.shape-default .ui-SegmentedControl-Item.is-active {\n  background-color: #000;\n  color: #fff;\n}\n\n.shape-normal {\n  width: 100%;\n  height: 38px;\n  gap: 8px;\n}\n\n.shape-normal .ui-SegmentedControl-Item {\n  height: 38px;\n  flex: 1 0 0;\n  padding: 0 16px 1px;\n  border: 1px solid #c9c9c9;\n  border-radius: 19px;\n  background-color: #fff;\n  color: #666;\n  font-size: 0.8125rem; /* 13px */\n  font-weight: 600;\n  line-height: 1.2727;\n}\n\n.shape-normal .ui-SegmentedControl-Item.is-active {\n  border-color: #000;\n  background-color: #f1e9de;\n  color: #1a1a1a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-SegmentedControl": `SegmentedControl-module__ui-SegmentedControl--QT8E3`,
	"ui-SegmentedControl-Item": `SegmentedControl-module__ui-SegmentedControl-Item--DOn35`,
	"shape-default": `SegmentedControl-module__shape-default--nNM5x`,
	"is-active": `SegmentedControl-module__is-active--uyNUj`,
	"shape-normal": `SegmentedControl-module__shape-normal--vyM_E`
};
export default ___CSS_LOADER_EXPORT___;
